import React from 'react'
import Allfood from './Allfood'

const FoodZone = () => {
  return (
    
    <div>
        <Allfood/>
    </div>
  )
}

export default FoodZone